import React, {useEffect, useState} from "react";
import TagList from "./TagList";
import {diff} from "radash";


export default ({itemChoices, onChange, items}) => {

    const [currentChoices, setCurrentChoices] = useState(itemChoices)


    useEffect(() => {
        setCurrentChoices(["...choisir", ...diff(itemChoices, items)]);
    }, [`>${items.length}`])

    return <div>
        <select
                className={
                    "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                }
                onChange={e => {
                    const updatedItemList = [...items, e.target.value]
                    onChange(updatedItemList)
                }}
                value={"...choisir"}
            >
                {currentChoices.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <TagList
            items={items}
            keyFunc={e => e}
            textFunc={e => e}
            onRemoveItem={removedItem => onChange(items.filter(i => i !== removedItem))}
        />

    </div>

}